import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Profile from '../../../Account/Profile/index';
import EmailConfirmation from '../../../Account/EmailConfimation/index';
import AdminResetPassword from '../../../Account/AdminResetPassword/index';

export default () => (
  <Switch>
    <Route path="/account/profile" component={Profile} />
    <Route path="/account/email_confirmation" component={EmailConfirmation} />
    <Route path="/account/admin/reset-password" component={AdminResetPassword}/>

  </Switch>
);
